import gql from 'graphql-tag'

export default gql`
mutation updateCardBalance($fields: LoyaltyCardItemWebInput) {
	cashAssist {
		updateCardBalance(fieldsWeb: $fields) {
			id
			balance
			points
		}
	}
}
`
